<template>
  <div class="bonus-summary">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-star-on"></i> Point Summary : <el-tag><span style="font-size: 1.2rem;">{{ point }}</span></el-tag></span>
        <div style="float:right; margin-left:5px">
          <el-button icon="el-icon-upload2" type="primary" @click="dialogFormVisible = true">Pay Bonus</el-button>
          <el-button icon="el-icon-download" type="success" @click="ExcelReport()">Excel</el-button>
        </div>

      </div>


      <data-tables 
          v-loading="loading" 
          :data="dataTable" 
          border 
          :page-size="20"
          :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
          <el-table-column prop="memberCode" label="Member Code" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="description" label="Description" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="monthlychargeId" label="Monthlycharge Id" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="bankholderId" label="BankholderID" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="date" label="Date" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="point" label="Point" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="type" label="Type" header-align="center" align="center">
            <template slot-scope="scope">
              <el-tag size="small" v-if="scope.row.type == 'credit'">Credit</el-tag>
              <el-tag size="small" type="danger"  v-if="scope.row.type == 'debit'">Debit</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="User" header-align="center" align="center"> </el-table-column>
        </data-tables>
    </el-card>

    <el-dialog title="Pay Bonus" width="30%" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="payBonusForm">
        <el-form-item label="BankholderID" prop="bankholderID">
          <el-select v-model="form.bankholderID" placeholder="Please select BankholderID">
            <el-option v-for="item of dataBankAccount" :key="item.uid" :label="`(${item.currency.toUpperCase()}) ${item.bankholderID}`" :value="item.bankholderID"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="payBonus()" :loading="submitting">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { introducerBonusSummary, introducerBonusSummaryExcel, payTheBonusReferral } from '@/api/introducer'
import { getBankAccountByCustomer } from '@/api/bank-account'
  export default {

  props:{
    projectUID: String
  },
  data(){
    return{
      loading: false,
      submitting: false,
      dialogFormVisible: false,
      dataTable:[],
      point: 0,
      dataBankAccount:[],
      form : {
        bankholderID: ""
      },
      rules:{
        bankholderID : [{required: true, message: 'Please select BankholderID', trigger: 'change'}]
      }
    }
  },
  methods:{
    getBonusSummary(){
      this.loading = true;
      introducerBonusSummary(this.$route.params.customer_uid).then(({result, data})=>{
        this.loading = false
        if(result){
          this.dataTable = data.records;
          this.point = data.point;
          
        }
      })
    },

    getBankAccount(){
      getBankAccountByCustomer(this.$route.params.customer_uid).then(({result, data})=>{
        if (result && data) {
            this.dataBankAccount = data.filter((item)=>{
              return item.status == 'active';
            });
          }
      });
    },

    payBonus(){
      this.$refs.payBonusForm.validate((valid) => {
        if(valid){
          this.submitting = true;
          payTheBonusReferral(this.$route.params.customer_uid, this.form.bankholderID).then(({result, message})=>{
            this.submitting = false;
            if(result){
              this.$notify({
                title: "Success",
                message: message,
                type: "success",
                duration: 2000,
              });
              this.dialogFormVisible = false;
              this.getBonusSummary();
              this.getBankAccount();
            }else{
              this.$notify({
              title: "Error",
              message: message,
              type: "error",
              duration: 2000,
            });
            }
          })
        }
      });
      
    },

    ExcelReport(){
      introducerBonusSummaryExcel(this.$route.params.customer_uid);
    },
  
  },
  created(){
    this.getBonusSummary();
    this.getBankAccount();
  }
  }
</script>

<style lang="scss" scoped>

</style>